import * as Bowser from 'bowser';

const browser = (typeof window !== 'undefined') ? Bowser.getParser(window.navigator.userAgent) : null;

interface EventListener {
  (evt: Event): void;
}

class Mouse {
  static addMouseDown(target: HTMLElement, callback: EventListener) {
    if (!browser) {
      return;
    }
    const eventName = browser.getPlatform().type === 'desktop' ? 'mousedown' : 'touchstart';
    target.addEventListener(eventName, callback);
  }

  static addMouseMove(target: HTMLElement, callback: EventListener) {
    if (!browser) {
      return;
    }
    const eventName = browser.getPlatform().type === 'desktop' ? 'mousemove' : 'touchmove';
    target.addEventListener(eventName, callback);
  }

  static addMouseUp(target: HTMLElement, callback: EventListener) {
    if (!browser) {
      return;
    }
    const eventName = browser.getPlatform().type === 'desktop' ? 'mouseup' : 'touchend';
    target.addEventListener(eventName, callback);
  }

  static removeMouseDown(target: HTMLElement, callback: EventListener) {
    if (!browser) {
      return;
    }
    const eventName = browser.getPlatform().type === 'desktop' ? 'mousedown' : 'touchstart';
    target.removeEventListener(eventName, callback);
  }

  static removeMouseMove(target: HTMLElement, callback: EventListener) {
    if (!browser) {
      return;
    }
    const eventName = browser.getPlatform().type === 'desktop' ? 'mousemove' : 'touchmove';
    target.removeEventListener(eventName, callback);
  }

  static removeMouseUp(target: HTMLElement, callback: EventListener) {
    if (!browser) {
      return;
    }
    const eventName = browser.getPlatform().type === 'desktop' ? 'mouseup' : 'touchend';
    target.removeEventListener(eventName, callback);
  }
}

export default Mouse;
